class AccountDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#AccountDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderAccountIconAccessibility();
    this.positionDropdown = this.positionDropdown.bind(this);
  }

  setHeaderAccountIconAccessibility() {
    const accountLink = document.querySelector('#account-icon-button');
    const accountLinkMobile = document.querySelector('#account-icon-button-mobile');
    
    [accountLink, accountLinkMobile].forEach((link) => {
      if (!link) return;

      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(link);
      });
      link.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(link);
        }
      });
    });
  }

  positionDropdown(triggerElement) {
    if (!triggerElement) return;
    
    const dropdown = this.querySelector('#AccountDrawer');
    if (!dropdown) return;

    // Only position on desktop
    if (window.innerWidth >= 990) {
      // Force a layout calculation to get accurate dimensions
      dropdown.style.visibility = 'hidden';
      dropdown.style.display = 'block';
      
      const rect = triggerElement.getBoundingClientRect();
      const dropdownWidth = dropdown.offsetWidth;
      const dropdownHeight = dropdown.offsetHeight;
      
      // Calculate position
      let top = rect.bottom + 8;
      let right = window.innerWidth - rect.right;
      
      // Adjust if dropdown would go off right edge
      if (rect.right - dropdownWidth < 0) {
        right = window.innerWidth - rect.right;
      } else {
        // Align right edge of dropdown with right edge of icon
        right = window.innerWidth - rect.right;
      }
      
      // Adjust if dropdown would go off bottom
      if (rect.bottom + dropdownHeight + 8 > window.innerHeight) {
        top = rect.top - dropdownHeight - 8;
      }
      
      // Apply positioning
      dropdown.style.position = 'fixed';
      dropdown.style.top = `${top}px`;
      dropdown.style.right = `${right}px`;
      dropdown.style.left = 'auto';
      dropdown.style.visibility = '';
      dropdown.style.display = '';
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Close mobile menu if open
    const menuDrawer = document.querySelector('menu-drawer');
    if (menuDrawer) {
      const detailsElement = menuDrawer.querySelector('details[open]');
      if (detailsElement && detailsElement.classList.contains('menu-opening')) {
        const closeEvent = new Event('close');
        menuDrawer.closeMenuDrawer(closeEvent);
      }
    }
    
    // Position dropdown on desktop (do this before showing)
    if (window.innerWidth >= 990) {
      this.positionDropdown(triggeredBy);
    }
    
    // Trigger animation
    requestAnimationFrame(() => {
      this.classList.add('active');
    });

    // Focus management for accessibility
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('AccountDrawer');
        const firstButton = containerToTrapFocusOn?.querySelector('a, button');
        if (firstButton && window.innerWidth < 990) {
          trapFocus(containerToTrapFocusOn, firstButton);
        }
      },
      { once: true }
    );

    // Only lock body scroll on mobile
    if (window.innerWidth < 990) {
      document.body.classList.add('overflow-hidden');
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('account-drawer', AccountDrawer);

